import dayjs from "dayjs";
import styles from "../mybooking.module.css";
import { Calendar, MapPin } from "react-feather";
import ActionMenu from "./ActionMenu";
import { Chip } from "@mui/material";

const BookingBlock = ({ item, setViewModalOpen, setViewId, setViewStr, setSendInvoiceModalOpen, setInvoiceMail, setInvoiceMailId, printBooking, setCancelModalOpen, setCancelId }) => {

    return <div className={`${styles.BookingCardUnderTop}`}>
        <div className={`${styles.MyBookConHead}`}>
            <p className={`${styles.BookingCarDeTitle}`}>
                {item?.booking_id}{" "}
                {parseInt(item?.status) === -1 ? (<span className={`${styles.Cancelled}`}>Cancelled</span>) : parseInt(item?.payment_status) === 1 ? (<span className={`${styles.Paid}`}>Paid</span>) : (<span className={`${styles.Unpaid}`}>Unpaid</span>)}

                {parseInt(item?.status) === 0 && <Chip label="Booked" variant="outlined" style={{ fontWeight: "600", backgroundColor: "#FFFFFF", borderColor: "#8C8C8C", color: "#8C8C8C", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                {parseInt(item?.status) === 1 && <Chip label="Assigned To Driver" variant="outlined" style={{ fontWeight: "600", backgroundColor: "rgb(253, 237, 233)", borderColor: "rgb(239, 35, 60)", color: "rgb(239, 35, 60)", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                {parseInt(item?.status) === 2 && <Chip label="Item Picked Up" variant="outlined" style={{ fontWeight: "600", backgroundColor: "rgb(253, 237, 233)", borderColor: "rgb(239, 35, 60)", color: "rgb(239, 35, 60)", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                {parseInt(item?.status) === 3 && <Chip label="Item In Warehouse" variant="outlined" style={{ fontWeight: "600", backgroundColor: "rgb(253, 237, 233)", borderColor: "rgb(239, 35, 60)", color: "rgb(239, 35, 60)", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                {parseInt(item?.status) === 4 && <Chip label="Shipped From Warehouse" variant="outlined" style={{ fontWeight: "600", backgroundColor: "rgba(121, 186, 247, 0.3)", borderColor: "rgb(8, 56, 161)", color: "rgb(8, 56, 161)", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                {parseInt(item?.status) === 5 && <Chip label="Received In GH Warehouse" variant="outlined" style={{ fontWeight: "600", backgroundColor: "rgba(121, 186, 247, 0.3)", borderColor: "rgb(8, 56, 161)", color: "rgb(8, 56, 161)", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                {parseInt(item?.status) === 6 && <Chip label="Out For Delivery" variant="outlined" style={{ fontWeight: "600", backgroundColor: "rgb(208, 247, 217)", borderColor: "rgb(2, 87, 40)", color: "rgb(2, 87, 40)", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                {parseInt(item?.status) === 7 && <Chip label="Delivered" variant="outlined" style={{ fontWeight: "600", backgroundColor: "rgb(208, 247, 217)", borderColor: "rgb(2, 87, 40)", color: "rgb(2, 87, 40)", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
            </p>

            <ActionMenu
                item={item}
                setViewModalOpen={setViewModalOpen.bind(this)}
                setViewId={setViewId.bind(this)}
                setViewStr={setViewStr.bind(this)}
                setSendInvoiceModalOpen={setSendInvoiceModalOpen.bind(this)}
                setInvoiceMailId={setInvoiceMailId.bind(this)}
                setInvoiceMail={setInvoiceMail.bind(this)}
                printBooking={printBooking.bind(this)}
                setCancelId={setCancelId.bind(this)}
                setCancelModalOpen={setCancelModalOpen.bind(this)}
            />
        </div>

        <div className={`${styles.MyBookConDeSec}`}>
            <p className={`${styles.BookingCarDeSTitle}`}>
                <span>Order Date:</span>{" "}
                {dayjs(item?.created_at).format("DD/MM/YYYY")}
            </p>
            <p className={`${styles.BookingCarDeSTitle}`}>
                <span>Total Amount:</span> £{parseFloat(item?.total).toFixed(2)}
            </p>
            <p className={`${styles.BookingCarDeSTitle}`}>
                <span>Paid Amount:</span> £{parseFloat(item?.paid_amount).toFixed(2)}
            </p>
            <p className={`${styles.BookingCarDeSTitle}`}>
                <span>Due Balance:</span> £{parseFloat(item?.due_balance).toFixed(2)}
            </p>
        </div>

        <div className={`${styles.MyBookConDeSec}`}>
            <p className={`${styles.BookingCarDeSTitle} ${styles.BookingCarDeSTitle2}`}>Pickup Details:</p>
            <p className={`${styles.BookingCarDeSTitle3}`}>
                <Calendar /> {dayjs(item?.created_at).format("DD/MM/YYYY LT")}
            </p>
            <p className={`${styles.BookingCarDeSTitle3}`}>
                <MapPin /> {item?.pickup_details?.address}
            </p>
        </div>
    </div>;
}

export default BookingBlock;